import {useSelector} from 'react-redux'
import CustomerWrapper from './customer/CustomerWrapper'
import DeliveryMethodWrapper from './deliveryMethod/DeliveryMethodWrapper'
import CustomerNote from './note/CustomerNoteWrapper'
import Payment from './payment/Payment'
import {RootState} from 'setup'
import {
  selectOrderErrors,
  selectOrderNote,
  selectOrderProcessErrors,
  selectViewOrderNotes,
} from 'app/features/orders/redux/order/orderEditSlice'
import {Errors} from 'app/features/orders/fulfillments/components'
// import OrderLineItemsWrapper from './lineItems/OrderLineItemsWrapper'
import CustomerNoteWrapper from './note/CustomerNoteWrapper'
import OrderItems from './lineItems/OrderItems'
import OrderHistoryWrapper from 'app/features/orders/componentsv1/edit/OrderHistoryWrapper'

export const OrderEditWrapper = () => {
  const errors = useSelector<RootState, any[]>(selectOrderErrors)
  const orderProcessErrors = useSelector<RootState, any[]>(selectOrderProcessErrors)
  const note = useSelector<RootState, any>(selectOrderNote)
  const notes = useSelector<RootState, any[]>(selectViewOrderNotes)

  return (
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-8'>
        <OrderItems />
        <Payment />
        <CustomerNoteWrapper note={note} notes={notes} isEditable />
      </div>
      <div className='col-xl-4'>
        <CustomerWrapper />
        <DeliveryMethodWrapper />
        <OrderHistoryWrapper />
        <Errors errors={errors} />
        <Errors errors={orderProcessErrors} isShowOnlyError />
      </div>
    </div>
  )
}

export default OrderEditWrapper
